import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useImportSeasonStages = () => {
  const { sport, organizationId, seasonId } = useParams();
  const request = useApi();

  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    mutationFn: async (fileName: string) =>
      await request(`${sport}/o/${organizationId}/seasons/${seasonId}/stages/import`, {
        method: "POST",
        body: { fileName },
      }),
  });
};
